import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { removeOldestQuery } from "@tanstack/react-query-persist-client";

const CACHE_KEY = "moringa-cache";
const OWNER_KEY = "moringa-cache-owner";
export const CACHE_MAX_AGE = 1000 * 60 * 60 * 24 * 7;
// Anything loaded before this moment came from the saved cache (shown while fresh data loads)
export const APP_START = Date.now();

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 60_000, refetchOnWindowFocus: false, gcTime: CACHE_MAX_AGE },
    },
});

export const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: CACHE_KEY,
    throttleTime: 2000,
    retry: removeOldestQuery, // if storage is full, drop the oldest queries instead of failing
});

export const persistOptions = {
    persister,
    maxAge: CACHE_MAX_AGE,
    buster: "v1",
    dehydrateOptions: { shouldDehydrateQuery: (q) => q.state.status === "success" },
};

export function clearSavedCache() {
    queryClient.clear();
    try { window.localStorage.removeItem(CACHE_KEY); window.localStorage.removeItem(OWNER_KEY); } catch { /* storage unavailable */ }
}

// Saved numbers belong to one user; a different sign-in on this device starts clean.
export function claimSavedCache(userId) {
    try {
        const owner = window.localStorage.getItem(OWNER_KEY);
        if (owner && owner !== String(userId)) clearSavedCache();
        window.localStorage.setItem(OWNER_KEY, String(userId));
    } catch { /* storage unavailable */ }
}
